import React, { useEffect, useState } from 'react';
import { compose } from "redux";
import { connect } from "react-redux";
import Product from "./Product";
import { addProductTh, deleteProductTh, getProductsTh, updateProductTh } from "../../redux/productReducer";

let mapStateToProps = (state) => ({
    products: state.productPage.products,
    totalPages: state.productPage.totalPages,
    totalElements: state.productPage.totalElements,
    size: state.productPage.size,
});

const ProductContainer = ({ getProductsTh, products, ...props }) => {
    // İlk render zamanı products hələ gəlməyibsə boş massiv mənimsədirik
    let [productList, setProductList] = useState(products || []);

    useEffect(() => {
        getProductsTh(0, 10);
    }, []);

    return (
        <div className="content-wrapper">
            <Product
                products={products}
                getProductsTh={getProductsTh}
                {...props}
            />
        </div>
    );
};

export default compose(
    connect(mapStateToProps, {
        getProductsTh,
        addProductTh,
        updateProductTh,
        deleteProductTh,
    })
)(ProductContainer);